export const LABEL_FILTER = (option, inputValue) => {
    const labelMatches = option.label.toLowerCase().includes(inputValue.toLowerCase());
    return labelMatches;
}